<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>Branch Fee</v-toolbar-title>
      </v-toolbar>
      <v-divider></v-divider>
      <v-card-text>
        <message :messages="messages"></message>
        <v-container fluid grid-list-lg>
          <v-layout row wrap>
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.branch }}</v-subheader>
              <div class="queryValue">{{ FeeForm.branch }}</div></v-flex
            >
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.dri }}</v-subheader>
              <div class="queryValue">{{ FeeForm.dri }}</div></v-flex
            >
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.effDate }}</v-subheader>
              <div class="queryValue">{{ FeeForm.effDate }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.riLevyPct }}</v-subheader>
              <div class="queryValue">{{ formatToFixed4(FeeForm.riLevyPct) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12 v-show="showThis"
              ><v-subheader class="queryLabel">{{ labels.busStpPct }}</v-subheader>
              <div class="queryValue">{{ formatToFixed2(FeeForm.busStpPct) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12 v-show="showThis"
              ><v-subheader class="queryLabel">{{ labels.busTaxPct }}</v-subheader>
              <div class="queryValue">{{ formatToFixed4(FeeForm.busTaxPct) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12></v-flex>
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.polStpGN }}</v-subheader>
              <div class="queryValue">{{ getGNLabel(FeeForm.polStpGN) }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.polStpPct }}</v-subheader>
              <div class="queryValue">{{ formatToFixed4(FeeForm.polStpPct) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.minPolStp }}</v-subheader>
              <div class="queryValue">{{ formatToFixed2(FeeForm.minPolStp) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.maxPolStp }}</v-subheader>
              <div class="queryValue">{{ formatToFixed2(FeeForm.maxPolStp) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.polStpRnd }}</v-subheader>
              <div class="queryValue">{{ formatToFixed2(FeeForm.polStpRnd) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.polFee }}</v-subheader>
              <div class="queryValue">{{ formatToFixed2(FeeForm.polFee) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.polTaxGN }}</v-subheader>
              <div class="queryValue">{{ getGNLabel(FeeForm.polTaxGN) }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.polTaxPct }}</v-subheader>
              <div class="queryValue">{{ formatToFixed4(FeeForm.polTaxPct) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.minPolTax }}</v-subheader>
              <div class="queryValue">{{ formatToFixed2(FeeForm.minPolTax) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.maxPolTax }}</v-subheader>
              <div class="queryValue">{{ formatToFixed2(FeeForm.maxPolTax) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.riskStpGN }}</v-subheader>
              <div class="queryValue">{{ getGNLabel(FeeForm.riskStpGN) }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.riskStpPct }}</v-subheader>
              <div class="queryValue">{{ formatToFixed4(FeeForm.riskStpPct) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.riskFeeGN }}</v-subheader>
              <div class="queryValue">{{ getGNLabel(FeeForm.riskFeeGN) }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.riskFeePct }}</v-subheader>
              <div class="queryValue">{{ formatToFixed4(FeeForm.riskFeePct) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.riskTaxGN }}</v-subheader>
              <div class="queryValue">{{ getGNLabel(FeeForm.riskTaxGN) }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12
              ><v-subheader class="queryLabel">{{ labels.riskTaxPct }}</v-subheader>
              <div class="queryValue">{{ formatToFixed4(FeeForm.riskTaxPct) }}</div></v-flex
            >
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.createdBy }}</v-subheader>
              <div class="queryValue">{{ createdName }}</div>
            </v-flex>
            <v-flex lg6 md6 xs12>
              <v-subheader class="queryLabel">{{ labels.createdDate }}</v-subheader>
              <div class="queryValue">{{ FeeForm.createdDate }}</div>
            </v-flex>
          </v-layout>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="red darken-1" text @click.native="doCancel">Close</v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { mapGetters } from 'vuex'

export default {
  props: {
    FeeForm: Object,
    createdName: String
  },
  data() {
    return {
      showThis: false,
      breadcrumb: [],
      labels: {
        branch: 'Branch',
        dri: 'Direct / RI Inwards',
        effDate: 'Effective Date',
        riLevyPct: 'RI Levy %',
        busStpPct: 'Business Stamp %',
        busTaxPct: 'Business Tax %',
        polStpGN: 'Policy Stamp on',
        polStpPct: 'Policy Stamp %',
        minPolStp: 'Minimum Policy Stamp',
        maxPolStp: 'Maximum Policy Stamp',
        polStpRnd: 'Policy Stamp Rounding value',
        polFee: 'Policy Fee',
        polTaxGN: 'Policy Tax on',
        polTaxPct: 'Policy Tax %',
        minPolTax: 'Minimum Policy Tax',
        maxPolTax: 'Maximum Policy Tax',
        riskStpGN: 'Risk Stamp on',
        riskStpPct: 'Risk Stamp %',
        riskFeeGN: 'Risk Fee on',
        riskFeePct: 'Risk Fee %',
        riskTaxGN: 'Risk Tax on',
        riskTaxPct: 'Risk Tax %',
        createdBy: 'Created By',
        createdDate: 'Created Date'
      }
    }
  },
  methods: {
    formatToFixed4(value) {
      return value.toFixed(4)
    },
    formatToFixed2(value) {
      return value.toFixed(2)
    },
    getGNLabel(gn) {
      if (gn === 'G') {
        return 'G - Gross'
      } else {
        return 'N - Net'
      }
    },
    doCancel() {
      this.$emit('close')
    }
  },
  computed: {
    ...mapGetters(['checkAccess'])
  },
  mixins: [TableConst.default, MessageMixin]
}
</script>

<style>
</style>
